import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-welcome',
	templateUrl: './welcome.component.html',
	styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent {

	@Input() welcome: boolean = false;

	close() {
		this.welcome = false;
	}
}
